(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var imgs = document.querySelectorAll('.footer__bg[data-parallax]');
    if (!imgs.length || reduce.matches) return;

    var ticking = false;
    var active = [];

    function update() {
      ticking = false;
      var vh = window.innerHeight;
      for (var i = 0; i < active.length; i++) {
        var img = active[i];
        var hero = img.parentElement;
        var rect = hero.getBoundingClientRect();
        // progress: 0 as the hero's top enters the bottom of the viewport,
        // 1 as its bottom leaves the top. Centred so offset is 0 mid-screen.
        var progress = (vh - rect.top) / (vh + rect.height);
        progress = Math.max(0, Math.min(1, progress));
        var intensity = parseFloat(img.getAttribute('data-parallax-intensity')) || 45;
        var offset = (progress - 0.5) * intensity * 2;
        // scale(1.25) matches the Tailwind scale-125 headroom on the image.
        img.style.transform = 'translate3d(0,' + offset.toFixed(1) + 'px,0) scale(1.25)';
      }
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }

    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        var el = entries[i].target;
        var idx = active.indexOf(el);
        if (entries[i].isIntersecting) {
          if (idx === -1) active.push(el);
        } else if (idx !== -1) {
          active.splice(idx, 1);
        }
      }
      if (active.length) {
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
      } else {
        window.removeEventListener('scroll', onScroll);
      }
    }, { rootMargin: '100px 0px' });

    for (var i = 0; i < imgs.length; i++) {
      io.observe(imgs[i]);
    }
  })();

  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var footers = document.querySelectorAll('.footer[data-footer-reveal]');
    if (!footers.length || reduce.matches) return;

    var ticking = false;
    // Cached layout height per footer — the scroll range over which it rises.
    // Only changes on layout, so it's measured in refresh(), not every frame.
    var ranges = [];

    function measure() {
      for (var i = 0; i < footers.length; i++) {
        ranges[i] = footers[i].offsetHeight || window.innerHeight;
      }
    }

    function update() {
      ticking = false;
      var doc = document.documentElement;
      var vh = window.innerHeight;
      // How far the bottom of the page still is from the bottom of the viewport.
      var distanceToBottom = (doc.scrollHeight - (window.scrollY + vh));
      for (var i = 0; i < footers.length; i++) {
        var footer = footers[i];
        var travel = parseFloat(footer.getAttribute('data-footer-reveal-distance')) || 140;
        // Spread the rise across the footer's whole entrance (its full height of
        // scrolling), not just `travel` px — so it's a gradual climb, not a snap.
        var range = ranges[i] || footer.offsetHeight || vh;
        // t = 1 the moment the footer starts entering → sits `travel` px low;
        // eases linearly to 0 as the page bottom meets the viewport → gap closes.
        var t = Math.max(0, Math.min(1, distanceToBottom / range));
        var offset = t * travel;
        footer.style.transform = 'translate3d(0,' + offset.toFixed(1) + 'px,0)';
      }
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }

    // Re-measure + reposition whenever the page can change height without a
    // scroll: lazy images decoding, fonts swapping, third-party widgets
    // (Trustpilot etc.) injecting, accordions/drawers expanding. Without this
    // the footer keeps a stale offset (wrong gap) until the next scroll.
    function refresh() {
      measure();
      onScroll();
    }

    measure();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', refresh, { passive: true });
    window.addEventListener('load', refresh);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(refresh);
    }
    if (window.ResizeObserver) {
      // transform doesn't affect layout, so this won't feed back on itself.
      new ResizeObserver(refresh).observe(document.body);
    }
    update();
  })();

  (function () {
    var mql = window.matchMedia('(min-width: 640px)');
    function syncFooterMenus() {
      var menus = document.querySelectorAll('.footer__menu');
      for (var i = 0; i < menus.length; i++) {
        menus[i].open = mql.matches;
      }
    }
    function init() {
      syncFooterMenus();
      if (mql.addEventListener) {
        mql.addEventListener('change', syncFooterMenus);
      } else if (mql.addListener) {
        mql.addListener(syncFooterMenus);
      }
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
